<template>

<button :class="buttonClass" type="button" @click="onClick">
  <svg viewBox="0 0 20 20">
    <path d="M1 1 19 19M19 1 1 19" stroke="#413E3E" stroke-width="2" stroke-linecap="round" />
  </svg>
</button>

</template>

<script setup>
import { computed } from 'vue';

defineOptions({ name: 'CloseButton' });
const props = defineProps({
  class: String,
  crossSize: { type: Number, default: 20 },
});
const emit = defineEmits(['click']);
const onClick = (event) => emit('click', event);
const buttonClass = computed(() => ['closeButton', props.class]);

</script>

<style lang="sass">

.closeButton
  flex: 0 0 auto

  display: flex
  align-items: center
  justify-content: center
  width: 32px
  height: 32px

  position: relative

  cursor: pointer
  border: 0
  background-color: transparent

.closeButton svg
  display: block
  width: 20px
  height: 20px

  pointer-events: none

</style>
